<template>
  <div class="container price-lookup-container">
    <button
      type="button"
      class="kiosk-toggle"
      :title="kioskMode ? 'Salir de modo kiosco' : 'Entrar a modo kiosco'"
      @click="toggleKiosk"
    >
      <i :class="kioskMode ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'"></i>
    </button>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Consultar precio</h1>
          <p class="view-header__subtitle">Escaneá o ingresá el código del producto para ver su precio.</p>
        </div>
      </div>
    </div>
    <!------------- FILTROS ----------------->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-upc-scan"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input
              ref="codeInput"
              type="text"
              class="form-control form-control-lg"
              v-model="code"
              v-on:keypress="lookupProducts"
              v-focus
              placeholder="Ingresá o escaneá el código del producto..."
            >
          </div>
        </div>
      </div>
    </div>

    <div class="form-card price-lookup-card">
      <div class="form-card__header">
        <h2 class="form-card__title">
          <i class="bi bi-tag"></i>
          Resultado
        </h2>
        <span v-if="countdown > 0" class="price-lookup__countdown">
          <i class="bi bi-arrow-clockwise"></i>
          Listo en {{ countdown }}s
        </span>
      </div>
      <div class="form-card__body">
        <div v-if="product.id != null" class="price-lookup__result row">
          <div class="col-12 col-md-4 d-flex justify-content-center align-items-center">
            <img
              class="price-lookup__image"
              :src="prodImage.length === 0 ? '/ph-product.png' : createurl(prodImage)"
            >
          </div>
          <div class="col-12 col-md-8 mt-4 mt-md-0">
            <p class="price-lookup__name">{{ product.name }}</p>
            <p class="price-lookup__price">{{ formatoDinamicoMoneda(product.price) }}</p>
            <dl class="price-lookup__meta">
              <div>
                <dt>Cod. interno</dt>
                <dd>{{ product.code }}</dd>
              </div>
              <div>
                <dt>Cod. de barra</dt>
                <dd>{{ product.barcode }}</dd>
              </div>
            </dl>
          </div>
        </div>
        <div v-else-if="notFound" class="price-lookup__empty price-lookup__empty--error">
          <i class="bi bi-exclamation-triangle"></i>
          <p class="price-lookup__empty-title">Producto no encontrado</p>
          <p class="price-lookup__empty-hint">No encontramos un producto con ese código. Volvé a intentarlo o pedí asistencia.</p>
        </div>
        <div v-else class="price-lookup__empty">
          <i class="bi bi-upc-scan"></i>
          <p class="price-lookup__empty-title">Escaneá el código de barra del producto</p>
          <p class="price-lookup__empty-hint">El precio aparecerá acá una vez que se reconozca el código.</p>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { mapState } from 'vuex'
  import formatMoneyMixin from "../../../mixins/formatMoneyMixin";

  export default {
    mixins: [formatMoneyMixin],
    directives: {
      focus: {
        inserted: function (el) {
          el.focus();
        }
      }
    },
    data: function() {
      return {
        bucket: 'productimages-qupro-prod',
        region: 'sa-east-1',
        code: '',
        product: [],
        prodImage: [],
        notFound: false,
        resetTimer: null,
        countdown: 0,
        kioskMode: localStorage.getItem('priceLookupKiosk') === '1',
      };
    },
    computed: {
      ...mapState('authUser',{
        authUser: state => state.authUser,
      }),
    },
    created () {
      this.$store.dispatch('authUser/getAuthUser')
    },
    mounted () {
      if (this.kioskMode) {
        document.body.classList.add('kiosk-mode');
      }
      this.focusInput();
    },
    beforeDestroy () {
      document.body.classList.remove('kiosk-mode');
      this.clearTimer();
    },
    methods: {
      createurl(img) {
        return 'https://'+this.bucket+'.s3.'+this.region+'.amazonaws.com/company_'+this.authUser.company_id+'/'+img;
      },
      focusInput() {
        this.$nextTick(() => {
          if (this.$refs.codeInput) this.$refs.codeInput.focus();
        });
      },
      clearTimer() {
        if (this.resetTimer) {
          clearInterval(this.resetTimer);
          this.resetTimer = null;
        }
        this.countdown = 0;
      },
      clearResult() {
        this.product = [];
        this.prodImage = [];
        this.notFound = false;
        this.clearTimer();
      },
      scheduleReset() {
        this.clearTimer();
        this.countdown = 4;
        this.resetTimer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            this.clearTimer();
            this.code = '';
            this.product = [];
            this.prodImage = [];
            this.notFound = false;
            this.focusInput();
          }
        }, 1000);
      },
      toggleKiosk() {
        this.kioskMode = !this.kioskMode;
        localStorage.setItem('priceLookupKiosk', this.kioskMode ? '1' : '0');
        document.body.classList.toggle('kiosk-mode', this.kioskMode);
        this.focusInput();
      },
      lookupProducts: function(e) {
        var hasResult = (this.product && this.product.id != null) || this.notFound;
        if (hasResult && e.key !== 'Enter') {
          this.clearResult();
        }
        if (e.key === 'Enter') {
          this.addProductByCode();
        }
      },
      addProductByCode: function(){
        var app = this;
        var co = app.code;

        if (co != null && co.length > 0) {
          axios.get('/api/products/getProductByCodeAndBarcode/'+co+'/1')
          .then(function(response) {
            var data = response.data && response.data.data;
            if (data && data.products) {
              app.product = data.products;
              app.prodImage = (data.prodImage && data.prodImage.length > 0)
                ? data.prodImage[0].url
                : [];
              app.notFound = false;
            } else {
              app.product = [];
              app.prodImage = [];
              app.notFound = true;
              app.$store.dispatch('errors/clearErrors');
            }
            app.code = '';
            app.scheduleReset();
            app.focusInput();
          })
          .catch(function() {
            app.product = [];
            app.prodImage = [];
            app.notFound = true;
            app.$store.dispatch('errors/clearErrors');
            app.code = '';
            app.scheduleReset();
            app.focusInput();
          });
        }
      },
    },
  };
  </script>

  <style scoped>
  .price-lookup-container {
    position: relative;
    min-height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    margin-left: auto;
    margin-right: auto;
  }

  .kiosk-toggle {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--surface);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    cursor: pointer;
    transition: background-color 0.15s, border-color 0.15s, color 0.15s;
    z-index: 10;
  }

  .kiosk-toggle:hover,
  .kiosk-toggle:focus {
    background: var(--surface-hover);
    outline: none;
  }

  .kiosk-toggle i {
    font-size: 18px;
  }

  .price-lookup__countdown {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-muted);
    background: var(--surface-hover);
    border: 1px solid var(--border-soft);
    border-radius: 999px;
    padding: 4px 10px;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
  }

  .price-lookup__countdown i {
    font-size: 12px;
  }

  .price-lookup-card .form-card__body {
    min-height: 320px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .price-lookup__image {
    width: 100%;
    max-width: 240px;
    height: 240px;
    object-fit: contain;
    border-radius: 12px;
    background: var(--surface-hover);
    border: 1px solid var(--border-soft);
    padding: 8px;
  }

  .price-lookup__name {
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: var(--text);
    margin: 0 0 8px;
    line-height: 1.3;
  }

  .price-lookup__price {
    text-align: left;
    font-size: 48px;
    font-weight: 700;
    color: var(--text);
    line-height: 1.1;
    margin: 0 0 20px;
  }

  .price-lookup__meta {
    text-align: left;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px 20px;
    margin: 0;
  }

  .price-lookup__meta dt {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin: 0 0 2px;
  }

  .price-lookup__meta dd {
    font-size: 14px;
    color: var(--text);
    margin: 0;
    word-break: break-all;
  }

  .price-lookup__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 48px 16px;
    color: var(--text-muted);
  }

  .price-lookup__empty i {
    font-size: 48px;
    color: var(--border-strong);
    margin-bottom: 16px;
  }

  .price-lookup__empty--error i {
    color: #c53030;
  }

  .price-lookup__empty--error .price-lookup__empty-title {
    color: #c53030;
  }

  .price-lookup__empty-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text);
    margin: 0 0 4px;
  }

  .price-lookup__empty-hint {
    font-size: 13px;
    color: var(--text-muted);
    margin: 0;
  }

  @media (max-width: 600px) {
    .price-lookup__price {
      font-size: 36px;
    }
  }
  </style>

  <style>
  body.kiosk-mode .navbar,
  body.kiosk-mode .lasubnav {
    display: none !important;
  }

  body.kiosk-mode .price-lookup-container {
    min-height: 100vh;
  }
  </style>